(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name flightWatch.controller:AddNewCheckCtrl
     *
     * @description
     *
     */
    angular
        .module('flightWatch')
        .controller('AddNewCheckCtrl', AddNewCheckCtrl);

    function AddNewCheckCtrl(modalParams, CommonMasterData, FlightWatch, $uibModalInstance, MessageService, PopupManager) {
        var vm = this;
        vm.airCraft = modalParams.airCraft;
        if(modalParams.type==="new"){
            vm.checkDetails = newCheckDTO();
        }
        else{
            vm.checkDetails = modalParams.checkDetails;
            if(vm.checkDetails.type === undefined){
                vm.checkDetails.type = 'Edit';
            }

        }

        vm.closeNewCheckPopUp = function () {
            $uibModalInstance.close();
        };

        vm.clearContent = function(){
            vm.checkDetails = newCheckDTO();
        };

        vm.startTimeChk = function (strID){
          var val = dateChk(strID);
          vm.checkDetails.checkStartTime = typeof val!== "boolean" ? val:"";

        };

        vm.endTimeChk = function (strID){
          var val = dateChk(strID);
          vm.checkDetails.checkEndTime = typeof val!== "boolean" ? val:"";
        };

        function dateChk(strID){
          var dtToday = new Date();
          var dtCurrH	= dtToday.getHours();
          var dtCurrM	= dtToday.getMinutes();

          var strEValue =strID;
          var blnReturn = true;
          var dtCreatH = dtCurrH;
          var dtCreatM = dtCurrM;

          strEValue = replaceall(strEValue, ":", "^");
          strEValue = replaceall(strEValue, ".", "^");
          strEValue = replaceall(strEValue, " ", "^");

          if (strEValue.indexOf("^") != -1){
            var arrDts = strEValue.split("^");
            switch (arrDts.length){
              case 1 :
                if (String(arrDts[0]) != ""){dtCreatH = arrDts[0];}
                break;
              case 2 :
                if (String(arrDts[0]) != ""){dtCreatH = arrDts[0];}
                if (String(arrDts[1]) != ""){dtCreatM = arrDts[1];}
                break;
              case 3 :
                if (String(arrDts[0]) != ""){dtCreatH = arrDts[0];}
                if (String(arrDts[1]) != ""){dtCreatM = arrDts[1];}
                break;
            }
          } else{
            var intCLength = strEValue.length;
            for (var i = 0 ; i < intCLength ; i++){
              if (i <= 1){
                if (i == 0){dtCreatH = "";}
                dtCreatH += strEValue.substr(i,1);
                dtCreatM = "00";
              }

              if (i > 1 && i <= 3){
                if (i == 2){
                  if (intCLength >= 4){
                    dtCreatM = "";
                    dtCreatM += strEValue.substr(i,1);
                  }else{
                    if (strEValue.substr(i,1) != 0){
                      dtCreatM = "";
                      dtCreatM += strEValue.substr(i,1);
                    }
                  }
                }else{
                  dtCreatM += strEValue.substr(i,1);
                }
              }
            }
          }

          // ----- Validate
          if (!validDate(dtCreatH, dtCreatM)){
            switch (strEValue.length){
              case 2 :
                if (Number(strEValue.substr(0,1)) > 0){dtCreatH = strEValue.substr(0,1);}
                if (Number(strEValue.substr(1,1)) > 0){dtCreatM = strEValue.substr(1,1);}
                break;
              case 3:
                if (Number(strEValue.substr(1,2)) <= 12) {
                  if (Number(strEValue.substr(0,1)) > 0){dtCreatH = strEValue.substr(0,1);}
                  if (Number(strEValue.substr(1,2)) > 0){dtCreatM = strEValue.substr(1,2);}
                }else{
                  if (Number(strEValue.substr(0,1)) > 0){dtCreatH = strEValue.substr(0,1);}
                  if (Number(strEValue.substr(1,1)) > 0){dtCreatM = strEValue.substr(1,1);}
                }
              case 4:
                if (Number(strEValue.substr(1,2)) <= 12) {
                  if (Number(strEValue.substr(0,1)) > 0){dtCreatH = strEValue.substr(0,1);}
                  if (Number(strEValue.substr(1,2)) > 0){dtCreatM = strEValue.substr(1,2);}
                }else{
                  if (Number(strEValue.substr(0,1)) > 0){dtCreatH = strEValue.substr(0,1);}
                  if (Number(strEValue.substr(1,1)) > 0){dtCreatM = strEValue.substr(1,1);}
                }
                break;
              default :

                blnReturn = false;

            }
          }

          if (!validDate(dtCreatH, dtCreatM)){

            blnReturn = false;

          }

          if (blnReturn && strEValue != ""){
            // ------------------------------------ Formatting the date
            var strFormat = "HH:mm";
            if (arguments.length == 2){
              if (arguments[1] != ""){
                strFormat = arguments[1];
              }
            }

            var strDefSep = "" ;
            var arrSep = new Array(":"," ",".");

            for (var i = 0 ; i < arrSep.length ; i++){
              if (strFormat.indexOf(arrSep[i]) != -1){
                strDefSep = arrSep[i];
                break;
              }
            }
            if (strDefSep == ""){

              blnReturn = false;

            }

            var strReturnDt = "";
            if (Number(dtCreatH) < 10){dtCreatH = "0" + Number(dtCreatH)};
            if (Number(dtCreatM) < 10){dtCreatM = "0" + Number(dtCreatM)};

            var strFormat1  = "HH" + strDefSep + "MM";

            switch (strFormat.toUpperCase()){
              case strFormat1	: strReturnDt = dtCreatH + strDefSep + dtCreatM; break;
            }


            return strReturnDt;

          }
          return blnReturn;

          function replaceall(strValue, strRepValue, strNValue){
            var i = strValue.indexOf(strRepValue);
            while(i > -1){
              strValue = strValue.replace(strRepValue, strNValue);
              i = strValue.indexOf(strRepValue);
            }
            return strValue
          }

          function validDate(dtH, dtM){
            if ((isNaN(dtH)) || (isNaN(dtM))){
              return false;
            }

            // is it Valid Time
            if (Number(dtM) > 59){
              return false;
            }

            if (Number(dtH) > 23){
              return false;
            }
            return true;
          }
        }

        vm.validationParam = {
            invalidCheckStartDate: false,
            invalidCheckStartTime: false,
            invalidCheckEndDate: false,
            invalidCheckEndTime: false,
            invalidCategory: false,
            invalidCheckDesc: false
        };

        // add new check - all fields mandatory
        vm.addCheck = function () {
            if (vm.addOrUpdateCheck.$dirty ){
                vm.addOrUpdateCheck.$submitted=true;
                var isValid= true;
                if(!vm.checkDetails.checkStartDate|| vm.checkDetails.checkStartDate === undefined || vm.checkDetails.checkStartDate==='' ){
                    vm.validationParam.invalidCheckStartDate =true;
                    isValid=false;
                }
                else{
                    vm.validationParam.invalidCheckStartDate =false;
                }
                if(!vm.checkDetails.checkStartTime || vm.checkDetails.checkStartTime === undefined || vm.checkDetails.checkStartTime==='' ){
                    vm.validationParam.invalidCheckStartTime =true;
                    isValid=false;
                }
                else{
                    vm.validationParam.invalidCheckStartTime =false;
                }
                if(!vm.checkDetails.checkEndDate || vm.checkDetails.checkEndDate === undefined || vm.checkDetails.checkEndDate==='' ){
                    vm.validationParam.invalidCheckEndDate =true;
                    isValid=false;
                }
                else{
                    vm.validationParam.invalidCheckEndDate =false;
                }
                if(!vm.checkDetails.checkEndTime || vm.checkDetails.checkEndTime === undefined || vm.checkDetails.checkEndTime==='' ){
                    vm.validationParam.invalidCheckEndTime =true;
                    isValid=false;
                }
                else{
                    vm.validationParam.invalidCheckEndTime =false;
                }
                /*if(!vm.checkDetails.dailyFlag && !vm.checkDetails.weeklyFlag && !vm.checkDetails.othersFlag){
                    vm.validationParam.invalidCategory =true;
                    isValid=false;
                }
                else{
                    vm.validationParam.invalidCategory =false;
                }*/
                if(!vm.checkDetails.checkDesc || vm.checkDetails.checkDesc === undefined || vm.checkDetails.checkDesc==='' ){
                    vm.validationParam.invalidCheckDesc =true;
                    isValid=false;
                }
                else{
                    vm.validationParam.invalidCheckDesc =false;
                }
                if(!!vm.checkDetails.checkStartDate && vm.checkDetails.checkStartTime &&  !!vm.checkDetails.checkEndDate && vm.checkDetails.checkEndTime){
                    var stDate = moment(vm.checkDetails.checkStartDate+' '+vm.checkDetails.checkStartTime,"DD/MM/YYYY HH:mm");
                    var edDate = moment(vm.checkDetails.checkEndDate+' '+vm.checkDetails.checkEndTime,"DD/MM/YYYY HH:mm");
                    if((edDate.isBefore(stDate)) || (moment(stDate).isSame(edDate))){
                        MessageService.warning(MessageService.MESSAGES.FLIGHT.ERROR_ADD_CHECK);
                        isValid=false;
                    }
                }

                if(isValid){
                  var checkParam = {
                    airCraft:vm.airCraft,
                    checkDetails:vm.checkDetails
                  };
                  $uibModalInstance.close(checkParam);
                }
            }
            else {
                MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_FORM_NOT_TOUCH);
            }


        };

        function newCheckDTO() {
            var check = {
                "aircraftRegId" : vm.airCraft.registrationID,
                "dailyFlag": false,
                "weeklyFlag": false,
                "othersFlag": false,
                "notOverlap": true,
                "checkDesc": "",
                "checkStartDate": "",
                "checkStartTime": "",
                "checkEndDate": "",
                "checkEndTime": "",
                "type":'new'
            };
            return check;
        }

    }


}());
